<template>
    <div id="app-wrap">
        <ModalWindow/>    
        <Site-Header/>
        <MobileMenu/>
        <main>
        <div :class="'outer-main-wrap ' + (uiStore.darkMode ? 'dark-mode' : 'light-mode')">
            <DarkModeToggle/>
            <div class="not-found-wrap inner-wrap">
                <h1>404: Track Not Found</h1>
                <p>
                Oops! Looks like you've hit a silent patch. <br>
                The page you're searching for must have been lost in the mix or deleted from the tracklist. <br>
                Don't worry, it's not your speakers – it's us.
                </p>
                <p>
                Let's get you back to the main stage. Tune in to our <NuxtLink to="/">Home Page</NuxtLink> or 
                try adjusting the EQ on your query. If you're looking for a specific plugin or impulse response, 
                make sure the spelling is pitch-perfect.
                </p>
                <p>
                    <NuxtLink to="/" class="fa-btn fa-btn-primary fa-btn-cta home-icon">Back to Home</NuxtLink>
                </p>
                <p>
                <ContactHint/>
                </p>

            </div>
            <FooterMenu/>
            <BackToTop/>
        </div>
        </main>
        <Site-Footer/>
        <CookiePopup/>
        <LiveChat/>
        <Popup/>
  </div>
</template>

<script setup lang="ts">
import { useUIStore } from '~/store/uiStore';

const uiStore = useUIStore();
</script>

<style lang="scss" scoped>
p {
    font-size: 1.25rem;
    margin-bottom: 1rem;
}
</style>